module.exports = __webpack_public_path__ + "img/krungsri-bank46x46.74e92af3.jpg";